module.exports = __webpack_public_path__ + "quilt1.41cf3ef0.png";